import React from 'react';
import PropTypes from 'prop-types';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import './PaginationSelect.scss';

const PaginationSelect = ({
  onPageChange,
  count,
  page,
}) => (
  <div className="pagination-select__buttons">
    <IconButton
      variant="contained"
      color="primary"
      size="small"
      disabled={page === 1}
      onClick={() => {
        onPageChange(page - 1);
      }}
    >
      <ChevronLeftIcon />
    </IconButton>
    <div className="pagination-select__select">
      <Select
        onChange={({ target: { value } }) => {
          onPageChange(value);
        }}
        value={page}
      >
        {new Array(Math.ceil(count / 15))
          .fill(undefined)
          .map((_, index) => (
            <MenuItem
              key={index + 1}
              value={index + 1}
            >
              {index + 1}
            </MenuItem>
        ))}
      </Select>
    </div>
    <IconButton
      variant="contained"
      color="primary"
      size="small"
      disabled={page === Math.ceil(count / 15)}
      onClick={() => {
        onPageChange(page + 1);
      }}
    >
      <ChevronRightIcon />
    </IconButton>
  </div>
);

PaginationSelect.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default PaginationSelect;



// WEBPACK FOOTER //
// ./src/common/components/PaginationSelect/PaginationSelect.js